window.moment = require('moment');
require('moment/locale/nl');

const currentYear = new Date().getFullYear(),
    today = moment(),
    kingsday = moment(currentYear+'-04-27'),
    memorialStart = moment(currentYear+'-05-04'),
    memorialEnd = moment(currentYear+'-05-05'),
    sinterklaasStart = moment(currentYear+'-11-15'),
    sinterklaasEnd = moment(currentYear+'-12-05'),
    christmasStart = moment(currentYear+'-12-12'),
    christmasEnd = moment(currentYear+'-12-26'),
    newyearStart = moment(currentYear+'-12-30'),
    newyearEnd = moment(currentYear+'-01-07'),
    $logo = $('.masthead__logo');

let isKingsday = today.isSame(kingsday, 'day'),
    isMemorial = today.isBetween(memorialStart, memorialEnd, 'day', '[]'),
    isSinterklaas = today.isBetween(sinterklaasStart, sinterklaasEnd, 'day', '[]'),
    isChristmas = today.isBetween(christmasStart, christmasEnd, 'day', '[]'),
    isNewyear = today.isBetween(newyearStart, moment(currentYear+'-12-31'), 'day', '[]') || today.isBetween(moment(currentYear+'-01-01'), newyearEnd, 'day', '[]');

if (isKingsday) $logo.addClass('masthead__logo--kingsday');
if (isMemorial) $logo.addClass('masthead__logo--memorial');
if (isSinterklaas) $logo.addClass('masthead__logo--sinterklaas');
if (isChristmas) $logo.addClass('masthead__logo--christmas');
if (isNewyear) $logo.addClass('masthead__logo--newyear');
